export default require('./Tooltip').default
